import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: 'map-change-dialog.component.html',
  styleUrls: ['map-change-dialog.component.scss'],
  standalone: false,
})
export class MapChangeDialogComponent {
  constructor(
    public dialog: MatDialogRef<MapChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MapDialogData,
  ) {}

  cancel(): void {
    this.dialog.close(false);
  }
}

export interface MapDialogData {
  fieldName: string;
  headerRow?: string;
}
